import React from 'react';

const LockScreen = () => <div className="lockScreen" />;

export default LockScreen;
